<template>
  <v-app id="client-login">
    <TheDebugBar />
    <v-main class="r2b_bg">
      <v-container class="fill-height" fluid>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6>
            <slot />
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import baseMixin from '@mixins/baseMixin'
import TheDebugBar from '@components/dev/the-debug-bar.vue'

export default {
  components: {
    TheDebugBar,
  },
  mixins: [baseMixin],
}
</script>
